import { Injectable } from '@angular/core';
import {
  StatisticService,
  STORE_STATISTIC_KEY
} from '@core/services/statistic.service';
import { Observable } from 'rxjs';
import { RugbyStatistic } from '@mtgame/core';

@Injectable()
export class RugbyStatisticService extends StatisticService {
  get statistic$(): Observable<RugbyStatistic[]> {
    return this.store.get(STORE_STATISTIC_KEY);
  }

  async loadStatistic(): Promise<RugbyStatistic[]> {
    const statistic = await this.tournamentApi.getRugbyStatistic(this.filters);
    this.store.save(STORE_STATISTIC_KEY, statistic.data);
    return statistic.data;
  }
}
